import React from 'react';
import './eventForm.css';

export default function LocationDetailsCard({ location, timezone, emptyMessage }) {
    const hasData = location?.country || location?.country_code;

    if (!hasData) {
        return (
            <div className="event-location-chips">
                <span className="event-location-chip event-location-chip--muted">
                    {emptyMessage || 'Select a place on the map to auto-fill location'}
                </span>
            </div>
        );
    }

    return (
        <div className="event-location-chips">
            {location.country ? (
                <span className="event-location-chip">Country: {location.country}</span>
            ) : null}
            {location.country_code ? (
                <span className="event-location-chip">Code: {location.country_code}</span>
            ) : null}
            {location.state ? (
                <span className="event-location-chip">State: {location.state}</span>
            ) : null}
            {location.state_code ? (
                <span className="event-location-chip">State code: {location.state_code}</span>
            ) : null}
            {timezone ? (
                <span className="event-location-chip">Timezone: {timezone}</span>
            ) : null}
        </div>
    );
}
